import type { IThemeRootProviderProps } from '@framework/theme/src/common/ThemeRootProvider';
import * as React from 'react';

export function ThemeRootProvider(props: IThemeRootProviderProps) {
  return <React.Fragment>{props.children}</React.Fragment>;
}
